import styled from 'styled-components';
import { Colors } from 'assets/colors';

export const StyledWrapper = styled.div`
  .campaigns-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 28px;
    gap: 16px;
  }

  .campaigns-title {
    font-weight: 800;
    font-size: 32px;
    line-height: 1.2;
    color: ${Colors.textPrimary1};
    margin: 0;
  }

  .campaigns-subtitle {
    font-size: 15px;
    color: #717679;
    margin-top: 6px;
  }

  .filters {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }

  /* Ant Design table header emphasis */
  .ant-table-thead > tr > th {
    font-weight: 700 !important;
    font-size: 13px !important;
    color: #1f1f1f !important;
    background: #f5f5f5 !important;
    text-transform: none;
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 12px 14px !important;
  }

  .ant-table-tbody > tr > td {
    font-size: 14px;
    vertical-align: middle;
  }

  .value-datetime {
    display: inline-flex;
    flex-direction: column;
    line-height: 1.35;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
  }

  .value-datetime .dt-time {
    color: #595959;
  }

  .campaign-name-link {
    font-weight: 600;
    color: ${Colors.primary1 || '#722ed1'};
    cursor: pointer;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .campaign-name-link:hover {
    text-decoration: underline;
  }

  .form-section {
    margin-bottom: 28px;
  }

  .form-section h3 {
    font-size: 18px;
    font-weight: 700;
    margin: 0 0 14px;
    color: ${Colors.textPrimary1};
  }

  /* Ant Design form labels on create/edit */
  .ant-form-item-label > label {
    font-weight: 700 !important;
    font-size: 14px !important;
    color: #1f1f1f !important;
    height: auto !important;
  }

  .audience-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 8px;
  }

  .recipient-count {
    margin-top: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #434343;
  }

  .recipient-error {
    margin-top: 8px;
    color: #cf1322;
    font-size: 13px;
  }

  .detail-meta {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px 32px;
    margin-bottom: 28px;
    padding: 20px 24px;
    background: #fafafa;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
  }

  .detail-meta .label {
    font-size: 15px;
    font-weight: 700;
    color: #1f1f1f;
    margin-bottom: 8px;
    letter-spacing: 0.01em;
  }

  .detail-meta .value {
    font-size: 15px;
    font-weight: 500;
    color: #434343;
    line-height: 1.45;
  }

  .detail-meta .value-datetime {
    letter-spacing: 0.01em;
  }

  .message-preview {
    white-space: pre-wrap;
    background: #fafafa;
    border: 1px solid #e8e8e8;
    padding: 16px 18px;
    border-radius: 8px;
    font-size: 14px;
    line-height: 1.5;
    color: #262626;
  }

  .success-fail-badges {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .success-fail-badges--compact {
    gap: 4px;
    flex-wrap: nowrap;
  }

  .success-fail-badges--compact .count-badge {
    min-width: 0;
    padding: 1px 8px;
    white-space: nowrap;
  }

  .count-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 64px;
    padding: 2px 10px;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 700;
    line-height: 22px;
    border: 1px solid transparent;
    white-space: nowrap;
  }

  .count-badge--success {
    color: #237804;
    background: #f6ffed;
    border-color: #b7eb8f;
  }

  .count-badge--failure {
    color: #a8071a;
    background: #fff1f0;
    border-color: #ffa39e;
  }

  .count-badge--skipped {
    color: #874d00;
    background: #fff7e6;
    border-color: #ffd591;
  }

  .back-link {
    padding: 0 0 8px !important;
    height: auto !important;
    font-weight: 600;
  }

  .recipients-value {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .recipients-toggle {
    flex: 0 0 auto;
  }

  .result-reason {
    margin-top: 8px;
    color: #a8071a;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.45;
    max-width: 420px;
  }

  .recipient-warning {
    margin-top: 8px;
    color: #874d00;
    font-size: 13px;
    line-height: 1.45;
  }
`;
